import styled from 'styled-components';

export const CarouselContainer = styled.div<{ isDragging: boolean }>`
	display: flex;
	gap: 30px;
	padding: 40px calc(50vw - 400px);
	overflow-x: auto;
	scroll-snap-type: x mandatory;
	scroll-behavior: smooth;
	cursor: ${props => (props.isDragging ? 'grabbing' : 'grab')};
	user-select: none;
	justify-content: flex-start;
	align-items: center;
	min-height: 500px;

	/* Hide scrollbar but keep functionality */
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		display: none;
	}

	/* Smooth scrolling on touch devices */
	-webkit-overflow-scrolling: touch;
`;

export const CarouselWrapper = styled.section`
	/* Break out of parent container to take full screen width */
	width: 100vw;
	margin-left: calc(-50vw + 50%);
	background: white;
	margin-top: 30px;
	margin-bottom: 30px;
`;

export const AnimatedCardWrapper = styled.div<{ isVisible: boolean }>`
	opacity: ${props => (props.isVisible ? 1 : 0)};
	transform: ${props => (props.isVisible ? 'translateX(0) scale(1)' : 'translateX(50px) scale(0.95)')};
	transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
	flex-shrink: 0;
	scroll-snap-align: center;

	/* Ensure proper centering when scrolled to */
	scroll-margin: 0 calc(50vw - 400px);
`;
